import React from "react";
import Sidebar from "../components/sidebar/Sidebar";
import Home from "../components/home/Home";
import { useLocation } from "react-router-dom";

// HomePage component renders the home interface with a sidebar and home content.
// It receives an openDrawer prop to control the sidebar drawer and extracts user data from the location state.
const HomePage = ({ openDrawer }) => {
  // useLocation hook provides access to the location object, which contains the state passed through navigation.
  const location = useLocation();

  // UserData object extracts user-specific data from the location state for rendering and authentication purposes.
  const UserData = {
    roles: location.state?.roles, // User roles (e.g., admin, user)
    isAdmin: location.state?.isAdmin, // Boolean flag indicating if the user is an admin
    isAuthenticated: location.state?.isAuthenticated, // Boolean flag indicating if the user is authenticated
    refreshToken: location.state?.refreshToken, // Token used to refresh user session
    accessToken: location.state?.accessToken, // Token used for API requests
    userId: location.state?.userId, // Unique identifier for the user
    username: location.state?.username, // Username of the authenticated user
  };

  return (
    <>
      {/* Sidebar component with openDrawer and userData props. 
                The Sidebar renders a navigation menu and uses userData for displaying user-specific information. */}
      <Sidebar openDrawer={openDrawer} userData={UserData} />

      {/* Home component that renders the main content for the home page.
                It receives the openDrawer prop to control the sidebar drawer. */}
      <Home openDrawer={openDrawer} />
    </>
  );
};

export default HomePage;
